import React, { useEffect, useState } from 'react';
import Layout from './components/layout/app';
import { BrowserRouter } from 'react-router-dom'
import './styles/styles.css'
import Units from './components/util/units';

function App() {
  const [unitsReady, setUnitsReady] = useState(!localStorage.getItem('access-token-jwt'));
  useEffect(() => {
    if (localStorage.getItem('access-token-jwt')) {
      Units.load().then(() => setUnitsReady(true));
    }
  }, []);

  if (!unitsReady) return null;

  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
